import React, { Component } from 'react';
import {Label, Switch} from 'app/components/Basics/';
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import './GlobalFieldLineComponent.scss';
import {QuestionFormContext} from '../../QuestionContext'
import { questionTypes } from '../../../../constants/question-types'
import { questionCategoriesOptions } from '../../../../constants/question-categories-options'
import { questionCategories } from '../../../../constants/question-categories'
import { questionInputLayoutTypes } from '../../../../constants/question-input-layout-types'

class GlobalFieldLine extends Component {

    static contextType = QuestionFormContext;

    constructor(props){
        super(props);
        this.state = {
            itsMe: true
        }        
    }

    changeQuestionTypeHandler(newType) {        
		var selectedQuestion = this.context.selectedQuestion;
		if (newType.value === 'NUMERIC') {
			if (selectedQuestion.layoutType === questionInputLayoutTypes.Button) {
				selectedQuestion.layoutType = questionInputLayoutTypes.DefaultInputType;
			}
			if (!selectedQuestion.options) {				
				selectedQuestion.options = [];
			}
			selectedQuestion.options = selectedQuestion.options.filter(opt => opt.value <= 0);
		}
		if (newType.value === 'OPEN' || newType.value === 'INTRO') {
			if (selectedQuestion.options) {				
				selectedQuestion.options = [];
			}
		}

        if (newType.value !== 'SS') {
            selectedQuestion.isSys = questionCategories.Default;
        }
		
		selectedQuestion.questionType = newType.value;   
        this.context.updateSelectedQuestion(selectedQuestion);
        this.props.questionTypeChange()
    }
    
    changeQuestionCategoryHandler(newCategory) {        
		var selectedQuestion = this.context.selectedQuestion;
		selectedQuestion.isSys = parseInt(newCategory.value);
        this.context.updateSelectedQuestion(selectedQuestion);        
    }

    getSelectedQuestionTypeOption() {
        var typeCode = this.context.selectedQuestion.questionType;
        return questionTypes.find(t=> t.value === typeCode)        
    }

    getGridSubTypeOptions() {
        return questionTypes.filter(t => t.value !== 'GGROUP' && t.value !== 'INTRO');
    }

    getSelectedGridSubTypeOption() {
        const gridSubTypeOptions = this.getGridSubTypeOptions();
        const selectedSubType = this.props.gridSubType;
        return gridSubTypeOptions.find(t => t.value === selectedSubType) || gridSubTypeOptions[0];
    }

    changeGridSubTypeHandler(newSubType) {
        this.props.changeGridSubType(newSubType.value);
    }

    getSelectedQuestionCategoryOption() {        
        return questionCategoriesOptions.find(t=> parseInt(t.value) === this.context.selectedQuestion.isSys);
    }

    changeFolderHandler(selectedItem) {
		var selectedQuestion = this.context.selectedQuestion;
		selectedQuestion.folderId = selectedItem ? selectedItem.value : null;
		this.context.updateSelectedQuestion(selectedQuestion);
    }

    getFolders() {		
		return this.props.folders.map(function (obj) {			
			return {value: obj.id, label: obj.name}
		});
	}

    getSelectedFolderOption() {
        var folders = this.getFolders();
        if (folders == null) {
            return null;
        }
        return folders.find(t=> t.value === this.context.selectedQuestion.folderId);
    }

    getLanguagesOptions() {		
		return this.props.languages.map(function (obj) {			
			return {value: obj.code, label: obj.description }
		});
	}

    getDefaultLanguage() {		
		return this.getLanguagesOptions().find(t=> t.isDefault === true);
	}

    getSelectedLanguage() {
        return this.getLanguagesOptions().find(t=> t.value === this.context.selectedLanguageCode)        
    }

    changeLanguageHandler(newLanguage) {        
		this.props.setSelectedLanguage(newLanguage.value);
    }    

    changeIsHiddenHandler(value) {
        var selectedQuestion = this.context.selectedQuestion;
        selectedQuestion.isHidden = value;
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    getValidQuestionCategoriesOptions() {
        if (this.context.selectedQuestion.questionType === 'SS') {
            return questionCategoriesOptions;
        }
        if (this.context.selectedQuestion.questionType !== 'GGROUP' && this.context.selectedQuestion.questionType !== 'INTRO') {
            return questionCategoriesOptions.filter(t => parseInt(t.value) !== questionCategories.Demographics);
        }
    }

    render() {
        return (
            <div className="GlobalFieldLineComponent form-row">
                <div className="form-row-left">
                    <div className="field-question-type">
                        <Label>Type</Label>
                        <Select isDisabled={!this.context.canChangeData} 
							name="qtype" isSearchable={false}
                            defaultValue={questionTypes[0]}
                            onChange={val=>{
                                this.changeQuestionTypeHandler(val)                                
                            }}
                            options={questionTypes} value={this.getSelectedQuestionTypeOption()}></Select>
                    </div>
                    {this.context.selectedQuestion.questionType === "GGROUP" && (
                    <div className="field-question-subtype">
                        <Label>Sub-Type</Label>
                        <Select isDisabled={!this.context.canChangeData}
							name="qsubtype" isSearchable={false}
                            defaultValue={this.getGridSubTypeOptions()[0]}
                            onChange={val=>{
                                this.changeGridSubTypeHandler(val)
                            }}
                            options={this.getGridSubTypeOptions()} value={this.getSelectedGridSubTypeOption()}></Select>
                    </div>
                    )}
                    {this.context.selectedQuestion.questionType !== "GGROUP" && this.context.selectedQuestion.questionType !== "INTRO" && (
                    <div className="field-question-category">
                        <Label>Category</Label>
                        <Select isDisabled={!this.context.canChangeData || !this.context.canChangeDemoQuestion || !this.context.canChangeHoneypotQuestion} 
							name="qcategory" isSearchable={false}
                            defaultValue={questionCategoriesOptions[0]}
                            onChange={val=>{
                                this.changeQuestionCategoryHandler(val)                                
                            }}
                            options={this.getValidQuestionCategoriesOptions()} value={this.getSelectedQuestionCategoryOption()}></Select>
                    </div>
                    )}
                    <div className="field-folder">
                        <Label>Folder</Label>
                        <Select name="qfolder" isSearchable={true} isClearable={true}                            
                            onChange={val=>{
                                this.changeFolderHandler(val)                                
                            }}							
                            options={this.getFolders()}
                            value={this.getSelectedFolderOption()}
                            isDisabled={!this.context.canChangeData}
                            key={this.context.selectedQuestion.folderId}
                            >							
                        </Select>
					</div>	
                    <div className="field-question-hidden">
                        <Label tooltip={(<div>Hidden questions are excluded from<br/>respondent-facing questionnaires<br/>but still included in exports.</div>)}>Hide</Label>
                        <div className="default-height centered"><Switch name="isHidden" checked={this.context.selectedQuestion.isHidden === true} setSwitchValue={this.changeIsHiddenHandler.bind(this)} disabled={!this.context.canChangeData} /></div>
                    </div>
                </div>
                <div className="form-row-right">
                    <div className="field-question-type">
                        <Label>Language</Label>
                        <Select isDisabled={!this.context.canChangeData} 
							name="language" isSearchable={false}
                            defaultValue={this.getDefaultLanguage()}
                            onChange={val=>{
                                this.changeLanguageHandler(val)                                
                            }}
                            options={this.getLanguagesOptions()} 
                            value={this.getSelectedLanguage()}></Select>
                    </div>
                </div>
            </div>
        );
    }
}

GlobalFieldLine.contextType = QuestionFormContext;

export default GlobalFieldLine;